import React from 'react';
import { Layout } from '../components/layout/Layout';
import { LegalDocumentContent } from '../components/LegalDocumentContent';
import { useLegalDocument } from '../hooks/useLegalDocument';

export default function Privacy() {
  const { document } = useLegalDocument('privacy');

  return (
    <Layout>
      <div className="section-padding">
        <div className="container-zinga">
          <h1 className="font-display text-3xl md:text-4xl font-bold mb-6">{document.title}</h1>
          <div className="card-zinga">
            <LegalDocumentContent content={document.content} />
          </div>
          <section className="card-zinga mt-8 space-y-4">
            <h2 className="font-display text-2xl font-semibold">Félbehagyott pénztár mentése</h2>
            <p>
              A pénztárban külön, opcionális jelölőnégyzettel hozzájárulhatsz ahhoz, hogy a
              rendszer a megadott kapcsolattartási és szállítási adatokat, valamint a kosár
              tartalmát akkor is elmentse, ha végül nem adod le a rendelést. A mentés csak
              érvényes e-mail-cím és aktív hozzájárulás után indul el, és nem feltétele a
              vásárlásnak.
            </p>
            <p>
              Az adatkezelés célja a félbehagyott vásárlási folyamat azonosíthatósága és
              ügyfélszolgálati kezelése, jogalapja a hozzájárulás. A mentett adatok: név,
              e-mail-cím, telefonszám, a megadott szállítási és számlázási adatok, a választott
              szállítási és fizetési mód, az átvételi pont, a kosár tételei és értéke, valamint
              a hozzájárulás és a mentés időpontja.
            </p>
            <p>
              A mentett adatokat legfeljebb 14 napig őrizzük meg. Sikeres rendeléskor, a
              hozzájárulás pénztárban történő visszavonásakor vagy adminisztrátori törléskor
              korábban is törlődnek. A rendszer naponta automatikusan eltávolítja a lejárt
              mentéseket.
            </p>
            <p>
              Ez a hozzájárulás nem marketingcélú hozzájárulás: ennek alapján reklám- vagy
              kosáremlékeztető e-mailt nem küldünk. A hozzájárulás visszavonása nem érinti a
              korábbi adatkezelés jogszerűségét. Törlési kérés a hello@lumenverde.hu címen is
              benyújtható.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
